import { Grid } from "@material-ui/core";
import { Box, IconButton, InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchBar = ({ searchQuery, onSearchInput, onSearchButtonClick }) => (
    <Grid
      item
      style={{
        display: "flex",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        maxWidth: "40%",
        borderRadius: 10,
        border: "1px solid rgba(0, 0, 0, 0.3)",
        padding: "1%",
      }}
    >
      <InputBase
        fullWidth
        placeholder="Search"
        value={searchQuery}
        onChange={onSearchInput}
        onKeyDown={(e) => {
          if (e.key === "Enter" && searchQuery.trim()) {
            onSearchButtonClick();
          }
        }}
        // startAdornment={
        //   <Box sx={{ display: "flex", alignItems: "center", marginRight: 1 }}>
        //     <SearchIcon />
        //   </Box>
        // }
      />
      <IconButton onClick={onSearchButtonClick} disabled={!searchQuery.trim()}>
        <SearchIcon />
      </IconButton>
    </Grid>
  );
  
export default SearchBar;